/* eslint-disable @typescript-eslint/no-explicit-any */
export const transformSessionResponse = item => {
  var _a, _b, _c, _d, _e, _f;
  const componentName = (_b = (_a = item.component) === null || _a === void 0 ? void 0 : _a.displayComponentName) !== null && _b !== void 0 ? _b : '';
  if (componentName === 'HOTEL_CARDS_MARKER') {
    return {
      content: '',
      role: '',
      date: new Date(item.date),
      displayComponentName: componentName,
      markerComponentProps: (_d = (_c = item.component) === null || _c === void 0 ? void 0 : _c.markerComponentProps) !== null && _d !== void 0 ? _d : '',
      vote: item.vote
    };
  }
  return {
    content: item.content,
    role: item.role,
    date: new Date(item.date),
    displayComponentName: componentName,
    markerComponentProps: (_f = (_e = item.component) === null || _e === void 0 ? void 0 : _e.markerComponentProps) !== null && _f !== void 0 ? _f : '',
    vote: item.vote
  };
};